/* eslint-disable react/no-array-index-key */
import { Col, Container, Row } from 'react-bootstrap';
import { IconCard } from '../../../Components/Card';
import { HeadingDesc, SectionHeadingSmall } from '../../../Components/Headings';
import img1 from '../../../assets/images/svg/health_data_platform1.svg';
import img2 from '../../../assets/images/svg/health_data_platform2.svg';
import img3 from '../../../assets/images/svg/health_data_platform3.svg';
import img4 from '../../../assets/images/svg/health_data_platform4.svg';
import img5 from '../../../assets/images/svg/health_data_platform5.svg';
import img6 from '../../../assets/images/svg/health_data_platform6.svg';
import img7 from '../../../assets/images/svg/health_data_platform7.svg';
import img8 from '../../../assets/images/svg/health_data_platform8.svg';
import './healthDataPlatform.css';

const healthDatas = [
  { image: img1, title: 'Heart Rate' },
  { image: img2, title: 'Sympathetic Stress' },
  { image: img3, title: 'Pulse Respirator Quotient' },
  { image: img4, title: 'Respiration Rate' },
  { image: img5, title: 'Blood Pressure' },
  { image: img6, title: 'Oxygen Saturation' },
  { image: img7, title: 'Heart Rate Variability' },
  { image: img8, title: 'Parasympathetic Activity' }
];
function HealthDataPlatform() {
  return (
    <Container>
      <section className="healthDataPlatform">
        <Row>
          <Col md={5}>
            <div className="content">
              <SectionHeadingSmall text="Meri Sehat Health Data Platform" />
              <HeadingDesc text="Meri Sehat’s Health Data Platform is an AI-powered, video-based, software-only solution that enables any industry in need of real-time health data to easily extract a wide range of health measurements with end-user agreement using personal electronic devices." />
            </div>
          </Col>
          <Col md={7}>
            <div className="icon_boxes">
              <Row>
                {healthDatas.map((healthData, index) => {
                  const { image, title } = healthData;
                  return (
                    <Col md={3} key={index}>
                      <IconCard img={image} desc={title} />
                    </Col>
                  );
                })}
              </Row>
            </div>
          </Col>
        </Row>
      </section>
    </Container>
  );
}

export default HealthDataPlatform;
